import apps from '../data/apps.json'
import centers from '../data/centers.json'
import { getURLParams } from '../../../shared/helpers/url_helper'
import { getSessionStorageItem, setSessionStorageItem } from '../../../shared/helpers/sessionStorage'

const getKiosk = () => {
  const params = getURLParams(window.location.search)
  let kioskSettings
  if (params.center) {
    kioskSettings = params
  } else {
    kioskSettings = getSessionStorageItem('kioskSettings') || {}
  }
  const {
    center = 'TEST',
    kioskId = 'testKiosk',
    app = 'aam',
    locale = 'en',
    directMessageTargetDeviceId,
  } = kioskSettings

  const tabletId = localStorage.getItem('FS.ds-tablet-id') // Tablet is set in localstorage on the ipad vs sessionStorage for longevity reasons

  const CENTER = centers[center]
  const APP = apps[app.toLowerCase()]
  const { orientations, websocket } = CENTER
  const {
    dockingVideo,
    undockRedirect,
    unauthRedirect,
    redirect = 'https://www.familysearch.org/discovery/about/kiosk',
    noDock,
  } = APP
  const orientation = orientations[app] || 'LANDSCAPE'
  const video = dockingVideo.replace('{orientation}', orientation).replace('{locale}', locale.toUpperCase())
  let url

  if (tabletId) {
    url = `${websocket}/?deviceType=tablet&tabletId=${tabletId}`
  } else {
    url = `${websocket}/?deviceType=kiosk&kioskId=${kioskId}`
  }

  const socket = new WebSocket(url)
  const kiosk = {
    center,
    kioskId,
    tabletId,
    app,
    locale,
    orientation,
    video,
    redirect,
    undockRedirect,
    unauthRedirect,
    directMessageTargetDeviceId,
    socketURL: url,
    noDock,
  }
  setSessionStorageItem({ kioskSettings: kiosk })

  return { socket, ...kiosk }
}
export default getKiosk
